'use client';

import { DotsVerticalIcon } from '@radix-ui/react-icons';
import { Forward, Heart, LucideIcon } from 'lucide-react';

import { ChatBubbleAction, ChatBubbleActionWrapper } from '@/slw/widgets/chat';

interface ActionIcon {
  icon: LucideIcon | typeof DotsVerticalIcon;
  type: string;
}

interface MessageActionsProps {
  onActionClick?: (actionType: string) => void;
  customActions?: ActionIcon[];
}

const defaultActionIcons: ActionIcon[] = [
  { icon: DotsVerticalIcon, type: 'More' },
  { icon: Forward, type: 'Like' },
  { icon: Heart, type: 'Share' },
];

export function MessageActions({ onActionClick, customActions }: MessageActionsProps) {
  const actionIcons = customActions || defaultActionIcons;

  const handleActionClick = (actionType: string) => {
    if (onActionClick) {
      onActionClick(actionType);
    } else {
      // Action clicked
    }
  };

  return (
    <ChatBubbleActionWrapper>
      {actionIcons.map(({ icon: Icon, type }) => (
        <ChatBubbleAction
          className='size-7'
          key={type}
          icon={<Icon className='size-4' />}
          onClick={() => handleActionClick(type)}
        />
      ))}
    </ChatBubbleActionWrapper>
  );
}